import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface PdfReportProps {
  pdfUrl: string | null;
}

const PdfReport: FC<PdfReportProps> = ({ pdfUrl }) => {
  const { t } = useTranslation("", { keyPrefix: "executeReports" });
  const pdfUrlWithZoom = `${pdfUrl}#view=FitH`;

  if (!pdfUrl) return null;

  return (
    <div className="flex flex-col w-full h-full">
      <object
        data={pdfUrlWithZoom}
        type="application/pdf"
        width="100%"
        height="100%"
        style={{ minHeight: "600px" }}
      >
        <p>
          {t("browserPdfSupportIssue")} <a href={pdfUrl}> {t("downloadPdf")}</a>
        </p>
      </object>
    </div>
  );
};

export { PdfReport };
